import React from 'react'
import "./LovedOneList.scss"

//material-UI

import Typography from "@material-ui/core/Typography";

function LovedOneList(props) {
  let { first_name, last_name} = props.lovedOnes || {};
  first_name = first_name || "";
  last_name = last_name || "";

  let fullName = (first_name
    ? first_name[0].toUpperCase() + first_name.substring(1)
    : "") +" "+ (last_name
    ? last_name[0].toUpperCase() + last_name.substring(1)
    : "");
  
    return (
        <div className="lovedOneList">
      
                <Typography component={'div'}>
                  <div className="leftData">
                    <div className="profileImgCard">
                      <div className="initialsCard">
                        <label>
                        {first_name.toUpperCase().charAt(0)}
              {last_name.toUpperCase().charAt(0)}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="rightData">
                    <div className="profileNameCard">
                    {fullName}
                      <div className="typeData">{props.lovedOnes.relation}</div>
                    </div>
                  </div>

                  
                </Typography>
             
      </div>
    )
}

export default LovedOneList
